import { createContext, useContext } from "react";

export const KeycloakContext = createContext(null);

export const useKeycloak = () => {
  const ctx = useContext(KeycloakContext);
  if (!ctx) {
    throw new Error("useKeycloak must be used within KeycloakProvider");
  }
  return ctx;
};
